/**
 * Noor Configuration
 * Centralized configuration for production settings
 */

export const NoorConfig = {
    // API Configuration
    api: {
        baseUrl: 'https://api.mnor.sbs/api/v1',
        endpoints: {
            login: '/auth/login',
            profile: '/user/profile',
            newsCreate: '/news/create'
        }
    },

    // XMPP/Converse.js Configuration
    xmpp: {
        // WebSocket connection URL
        websocketUrl: 'wss://cdn1.mnor.sbs:5443/ws',
        // Multi-User Chat domain
        mucDomain: 'chat.mnor.sbs',
        // Default domain for users
        defaultDomain: 'mnor.sbs',
        // Message archiving ('always', 'never', 'roster')
        messageArchiving: 'always',
        // Enable debug logging
        debug: false,
        // Prefer BOSH over WebSocket
        preferBosh: false,
        // Keep-alive
        keepalive: true,
        // Auto-reconnect
        autoReconnect: true,
        // Message carbons (sync messages across devices)
        messageCarbons: true
    },

    // Profile Refresh Configuration
    profile: {
        // Refresh interval in milliseconds (1 minute = 60000ms)
        refreshInterval: 60000,
        // Auto-refresh enabled by default
        autoRefresh: true,
        // Retry on failure
        retryOnFailure: true,
        // Max retry attempts
        maxRetries: 3
    },

    // UI Configuration
    ui: {
        // Show detailed console logs
        verboseLogging: false,
        // Show toast notifications
        showNotifications: true,
        // Theme
        theme: 'noor',
        darkTheme: 'noor',
        // View mode ('fullscreen', 'overlayed', 'mobile')
        viewMode: 'fullscreen',
        // Show background
        showBackground: true,
        // Locale
        locale: 'fa',
        availableLocales: ['fa']
    },

    // Map Configuration
    map: {
        tileUrl: 'https://map.misaq.me',
        defaultZoom: 6,
        defaultCenter: [32.4279, 53.6880] // Iran center
    },

    // Date Picker Configuration
    datePicker: {
        locale: 'fa',
        format: 'YYYY/MM/DD',
        timePicker: true
    },

    // Storage Configuration
    storage: {
        dbName: 'NoorDB',
        dbVersion: 2,
        // Auto-clear on logout
        clearOnLogout: true,
        // Persistent store type
        persistentStore: 'IndexedDB'
    }
};

/**
 * Get configuration value by path
 * Example: getConfig('profile.refreshInterval') returns 60000
 */
export function getConfig(path) {
    return path.split('.').reduce((obj, key) => obj?.[key], NoorConfig);
}

/**
 * Update configuration value
 * Example: setConfig('profile.refreshInterval', 120000)
 */
export function setConfig(path, value) {
    const keys = path.split('.');
    const lastKey = keys.pop();
    const target = keys.reduce((obj, key) => obj[key], NoorConfig);
    if (target) {
        target[lastKey] = value;
    }
}

export default NoorConfig;
